<template>
  <div v-if="productData" :class="rootCss" :style="showCard ? 'display:grid' : 'display:none'">
    <span class="closeQuickModal" v-on:click="closeModal" v-show="modal">
      <i class="lni lni-close"></i>
    </span>
    <AdvProductPageSignature
      v-if="null !== customizationSchema && showSignature && !isMobileOrTablet"
      class="desktop"
      ref="customizationEditor"
      :schema.sync="customizationSchema"
    />
    <slot name="unavailable" />
    <div class="quick-v-info">
      <slot name="bundles" />
      <slot name="prices" />
      <AdvProductPageSignature
        v-if="null !== customizationSchema && showSignature && isMobileOrTablet"
        class="mobile"
        ref="customizationEditor"
        :schema="customizationSchema"
      />

      <div v-if="isDigital && showDeviceSelectionPopup" class="device-selection-popup" ref="deviceSelectionPopup">
        <div class="device-selection-content">
          <span class="device-options-title">Επίλεξε τη συσκευή σου</span>
          <div class="device-options">
            <div class="device-option" @click="handleDeviceSelection('windows')">
              <img src="/ui/main/img/windows-logo.svg" alt="Windows" width="45" height="45" class="img-fluid">
              <span>Windows</span>
            </div>
            <div class="device-option" @click="handleDeviceSelection('android')">
              <img src="/ui/main/img/android-logo.svg" alt="Android" width="55" height="30" class="img-fluid">
              <span>Android</span>
            </div>
            <div v-if="epubAppleLink"
                 class="device-option apple"
                 @click="handleDeviceSelection('apple')"
                 @mouseover="showTooltip"
                 @mouseleave="hideTooltip"
            >
              <img src="/ui/main/img/apple-logo.svg"
                   alt="Apple"
                   width="42"
                   height="51"
                   class="img-fluid"
                   @mouseover="showTooltip"
                   @mouseleave="hideTooltip"
              >
              <span @mouseover="showTooltip" @mouseleave="hideTooltip">Apple</span>
              <p class="apple-tooltip">Ευχαριστούμε πολύ. Θα μεταφερθείς στο Apple Store.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Btn-->
      <div class="quick-v-tocart" v-if="!isFreeEbook">
        <adv-product-page-cart-button
          class="addToCart"
          :unavailable="unavailableProduct || cartLimitForProductReached"
          :cart-limit-reached="cartLimitForProductReached"
          :has-attributes="hasAttributes"
          :selected-attribute-id="selectedAttributeId"
          v-on:btn-click="addToCard"
          :stock="productCodeData.productStock"
          :progress="progress"
          :productId="productId"
          :product-code-id="productCodeId"
          :cart-quantity="cartQuantity"
          :product-meta-data="productMetaData"
          :availability-info="availabilityInfo"
          v-bind:quantity="quantity"></adv-product-page-cart-button>
      </div>
      <div v-else class="dioptra-free-ebook-download">
        <dialog class="dioptra-free-ebook-download-modal" ref="modal">
          <form class="dioptra-free-ebook-download-form"
                id="FreeEbookForm"
                name="FreeEbookForm"
                @submit.prevent="handleSubmit"
          >
            <div class="dioptra-free-ebook-download-head">
              <p class="dioptra-free-ebook-download-head-text">Κατέβασέ το</p>
              <button class="dioptra-free-ebook-download-close-button"
                      type="button"
                      aria-label="Close"
                      @click="$refs.modal.close()"
              >
                <span v-html="getExitModalIcon"></span>
              </button>
            </div>
            <div class="dioptra-free-ebook-download-body">
              <p class="dioptra-free-ebook-download-body-text">Συμπλήρωσε το email σου στο παρακάτω πεδίο και θα λάβεις το link για να κατεβάσεις ΔΩΡΕΑΝ
                το ebook <span class="product-name">{{ productData.productName }}</span>
              </p>
              <div class="form-group dioptra-input-wrapper">
                <input id="email"
                       name="email"
                       placeholder="Email*"
                       required="required"
                       type="email"
                       class="form-control dioptra-input-field"
                       data-placeholder="Email*"
                >
                <label for="email" class="customer-login-form-label dioptra-input-label">Email*</label>
              </div>
            </div>
            <div class="dioptra-free-ebook-download-footer">
              <slot name="captcha" />
              <div class="dioptra-free-ebook-download-button-container">
                <button type="submit" class="dioptra-free-ebook-download-button">
                  <span class="dioptra-free-ebook-download-button-text">Κατέβασέ το</span>
                </button>
              </div>

            </div>
          </form>
        </dialog>
        <button class="dioptra-free-ebook-download-open-button" @click="openModal">
          <span class="dioptra-free-ebook-download-open-button-text">Κατέβασέ το</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, get, isEmpty, some } from 'lodash-es'
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import AdvProductPageCartButton from './AdvProductPageCartButton'
import { mapActions, mapGetters } from 'vuex'
import AdvProductPageSignature from './AdvProductPageSignature.vue'
import cartButtonMixin from './mixins/cartButtonMixin'

export default {
  name: 'AdvProductPageCard',
  components: {
    AdvProductPageCartButton,
    AdvProductPageSignature
  },
  props: {
    productId: {
      type: Number
    },
    modal: {
      type: Boolean,
      default: false
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    },
    isDigital: {
      type: Boolean,
      default: false
    },
    epubAppleLink: {
      type: String,
      default: null
    },
    showSignature: {
      type: Boolean,
      default: true
    },
    productMetaData: {
      type: Object,
      default: () => ({})
    },
    availabilityInfo: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [productMixin, cartButtonMixin],
  data () {
    return {
      version: '0.0.2',
      productCodeId: null,
      quantity: 1,
      showCard: true,
      progress: false,
      mainImage: {
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      },
      showDeviceSelectionPopup: false,
      customizationSchema: null,
      isMobileOrTablet: window.innerWidth < 1199
    }
  },
  created() {
    this.customizationSchema = this.getCustomizationSchema
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutsidePopup)
    document.addEventListener('click', this.handleClickOutsideModal)
    this.setProductCodeIdForOneOnOne()
    this.setMainImage()
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutsidePopup)
    document.removeEventListener('click', this.handleClickOutsideModal)
  },
  watch: {
    productId () {
      this.setProductCodeIdForOneOnOne()
      this.setMainImage()
    }
  },
  computed: {
    ...mapGetters([
      'getUniqueProductVariationValueIds',
      'cartProductWithCustomizationQuantity',
      'cartProductCodeQuantity',
      'getSelectedCurrency',
      'cartContents'
    ]),
    ...mapGetters('cartProductCustomizations', ['getSchemaById']),
    ...mapGetters('productChart', ['getProductChartSettings']),
    rootCss () {
      if (this.modal) {
        return 'modalQuickV'
      }
      return ''
    },
    config () {
      return store.getters.config
    },
    hasAttributes () {
      return some(this.productData.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    getCustomizationSchema () {
      if (!('customizationSchemaId' in this.productData) || this.productData.customizationSchemaId === null) {
        return null
      }
      if (('customizationSchemaRange' in this.productData) && this.productData.customizationSchemaRange !== null) {
        const from = this.productData.customizationSchemaRange.from
        const to = this.productData.customizationSchemaRange.to
        if (from !== null && new Date(from) > new Date()) {
          return null
        }
        if (to !== null && new Date(to) < new Date()) {
          return null
        }
      }
      const schema = this.getSchemaById(this.productData.customizationSchemaId)
      if (!schema || !('schema' in schema) || ('is_active' in schema && schema.is_active === false)) {
        return null
      }
      return cloneDeep(schema)
    },
    hasVariationEntries () {
      return this.getUniqueProductVariationValueIds.length > 0
    },
    productPriceClass () {
      return 'col-xs-12 ' + (this.productData.productFinalPrice === this.productData.productOldPrice ? '' : 'col-sm-4 ') + 'text-right productItemMainPrice'
    },
    listImage () {
      return this.productData ? this.productData.productImage.list : store.getters.noImage
    },
    inactiveProduct () {
      return !this.productCodeData.productActive
    },
    unavailableProduct () {
      const firstEditionDate = this.productMetaData?.firstEditionDate ? new Date(this.productMetaData.firstEditionDate) : null
      if (firstEditionDate && firstEditionDate > new Date()) {
        return false
      }
      return (Number(this.productCodeData.productStock) + Number(this.productCodeData.productPendingStock)) <= 0 || this.productData.productFinalPrice <= 0
    },
    isProductInAvailabilityDate () {
      const { availableFrom, availableUntil } = this.productData
      const currentDate = Date.now()
      return (
        (availableFrom != null && currentDate < new Date(availableFrom).getTime()) ||
        (availableUntil != null && currentDate > new Date(availableUntil).getTime())
      )
    },
    cartLimitForProductReached () {
      const firstEditionDate = this.productMetaData?.firstEditionDate ? new Date(this.productMetaData.firstEditionDate) : null
      if (firstEditionDate && firstEditionDate > new Date()) {
        return false
      }
      return (Number(this.productCodeData.productStock) + Number(this.productCodeData.productPendingStock)) === Number(this.cartQuantity)
    },
    selectedAttributeId () {
      return parseFloat(store.getters.getSelectedAttributeId)
    },
    cartQuantity () {
      if (
        this.customizationSchema !== null &&
        !isEmpty(get(this, ['$refs', 'customizationEditor', 'getSchema']))
      ) {
        return this.cartProductWithCustomizationQuantity(
          this.productCodeId,
          this.customizationSchema.schema,
          0
        )
      }
      return this.cartProductCodeQuantity(this.productCodeId, 0)
    },
    maxAmountForInputSpinner () {
      return this.productCodeData.productStock - this.cartQuantity
    },
    variationsActive () {
      return store.getters.getVariationsActive
    },
    productChartSettings () {
      return this.getProductChartSettings
    },
    hasDiscount () {
      return this.productChartSettings?.enabled &&
        this.productData.priceTracking?.shouldDisplay &&
        this.productData.priceTracking?.discountPass
    },
    hasDiscountNoPriceTracking () {
      return !this.productChartSettings?.enabled && this.productData.productHasDiscount
    },
    isFreeEbook () {
      return this.productMetaData?.freeEbook === '1'
    },
    getExitModalIcon () {
      return '<i class="lni lni-close" style="font-size: 15px"></i>'
    },
  },
  methods: {
    ...mapActions(['addToCartClicked', 'setSelectedProductCodeId', 'setSelectedAttributeId']),
    setProductCodeIdForOneOnOne () {
      if (!this.hasAttributes) {
        this.codeIdChanged(this.productData.productCodes[0].productCodeId)
        return
      }

      this.quantity = 1
    },
    closeModal () {
      this.showCard = false
      this.$emit('close-quick-view')
      this.clearSelectedAttributeId()
    },
    clearSelectedAttributeId () {
      if (this.hasAttributes) {
        this.setSelectedAttributeId(null)
      }
    },
    priceWithSign (priceString, priceSign) {
      return (parseFloat(priceString) * this.getSelectedCurrency.rate).toFixed(2) + priceSign
    },
    getSign () {
      return this.getSelectedCurrency.symbol
    },
    diffStringPrices (priceA, priceB) {
      return (parseFloat(priceA) - parseFloat(priceB)).toFixed(2).toString()
    },
    attributeSelected (attributeId) {
      this.setSelectedAttributeId(attributeId)
    },
    codeIdChanged (productCodeId) {
      this.productCodeId = productCodeId
      if (this.productCodeId) {
        this.setSelectedProductCodeId(this.productCodeId)
        this.setMainImage()
      }
    },
    addToCard () {
      if (this.isDigital) {
        this.showDeviceSelectionPopup = true
      } else {
        this.addToCartDirectly()
      }
    },
    addToCartDirectly () {
      if ('customizationEditor' in this.$refs && !this.$refs.customizationEditor.validate()) {
        return
      }
      this.progress = true
      const cartPayload = {
        productCodeId: this.productCodeId,
        quantity: this.cartQuantity + this.quantity,
        recommendationId: this.recommendationId,
        recommendationType: this.recommendationType
      }
      if (this.customizationSchema !== null && this.$refs.customizationEditor) {
        cartPayload.cartProductCustomizations = this.$refs.customizationEditor.getSchema
      }
      this.addToCartClicked(cartPayload).then(() => {
        this.progress = false
        this.quantity = 1
      })
      this.$emit('add-to-cart')
    },
    setMainImage () {
      if (this.productCodeId) {
        this.mainImage = this.productData.images[this.productCodeId].find(image => image.is_main === '1')
      } else {
        this.mainImage = this.productData.images[parseInt(Object.keys(this.productData.images)[0])].find(image => image.is_main === '1')
      }
    },
    handleDeviceSelection (device) {
      if (device === 'apple') {
        const appleLink = this.epubAppleLink
        if (appleLink) {
          window.open(appleLink, '_blank')
        }
      } else {
        this.addToCartDirectly()
      }
      this.showDeviceSelectionPopup = false
    },
    handleClickOutsidePopup (event) {
      if (this.showDeviceSelectionPopup) {
        const popup = this.$refs.deviceSelectionPopup
        if (popup && !popup.contains(event.target) && !event.target.matches('.add-to-cart-btn') && !event.target.matches('.add-to-cart-btn-text')) {
          this.showDeviceSelectionPopup = false
        }
      }
    },
    handleClickOutsideModal (event) {
      const modal = this.$refs.modal
      if (!modal) {
        return
      }
      const rect = modal.getBoundingClientRect()
      const isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width)
      if (!isInDialog) {
        modal.close()
      }
    },
    openModal (event) {
      this.$refs.modal.showModal()
      event.stopPropagation()
    },
    handleSubmit () {
      const email = this.$refs.modal.querySelector('input[name="email"]').value
      const productId = this.productId
      fetch('/api/product/sendEbookDownloadLink', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, productId })
      })
        .then(response => response.json())
        .then(() => {
          this.$toasted.success(
            this.t('ebook.download.link.sent'),
            { duration: '2500' }
          )
          this.$refs.modal.close()
        })
        .catch((error) => {
          this.$toasted.error(
            this.t('ebook.download.link.error'),
            { duration: '2500' }
          )
        })
    },
    showTooltip (event) {
      const tooltip = event.target.querySelector('.apple-tooltip')
      if (!tooltip) {
        return
      }
      tooltip.style.display = 'block'
    },
    hideTooltip (event) {
      const tooltip = event.target.querySelector('.apple-tooltip')
      if (!tooltip) {
        return
      }
      tooltip.style.display = 'none'
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-v-info {
  position: relative;
  display: grid;
  width: 100%;
}
.quick-v-tocart {
  padding: 0;
}
.device-selection-popup {
  position: absolute;
  bottom: 15px;
  left: -20px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  @media screen and (max-width:1199px){
    left:0;
    right:0;
    margin:0 auto;
    max-width: 300px
  }
}

.device-selection-content {
  background: #fff;
  padding: 10px 15px 30px;
  border: 1px solid #231F20;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width:100%;
  width:100%;
  @media screen and (max-width:1199px){
    gap:25px
  }
}

.device-options {
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 60px;
  padding-left: 10px;
  padding-right: 10px;
  @media screen and (max-width:991px){
    padding:0;
    gap:25px
  }
}

.device-option {
  cursor: pointer;
  text-align: center;
  width: 100%;
  height: 100%;
  display: grid;
  justify-items: center;
  align-items: center;
  gap: 10px;
  position: relative;
  img{
    @media screen and (max-width:991px){
      max-width: 30px
    }
  }
  &.apple {
    &:hover {
      .apple-tooltip {
        display: block !important;
      }
    }
  }
}

.device-options-title {
  color: #231F20;
  font-size: 17px;
  font-weight: 700;
  border-bottom: 1px solid #231F20;
  padding-bottom: 10px;
  text-align: center;
}

.device-option span {
  display: block;
}
.dioptra-free-ebook-download-modal {
  box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, .2);
  border-radius: 6px;
  outline: 0;
  max-width: 600px;
  padding: 0;
}
.dioptra-free-ebook-download-form {
  position: relative;
  display: grid;
  gap: 0.5rem;
}
.dioptra-free-ebook-download-head {
  position: relative;
  border-bottom: 1px solid #e5e5e5;
  padding: 1rem;
}
.dioptra-free-ebook-download-body {
  display: grid;
  padding: 1rem;
  gap: 1.25rem;
}
.dioptra-free-ebook-download-footer {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  justify-content: end;
  align-items: center;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
}
.dioptra-free-ebook-download-open-button {
  align-items: center;
  background-color: #231f20;
  display: flex;
  gap: 15px;
  height: 56px;
  justify-content: center;
  border: 0;
  color: #fff;
  font-size: 16px;
  padding: 0;
  text-align: center;
  transition: all .3s ease-in-out;
  width: 100%;
}
.dioptra-free-ebook-download-open-button-text {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}
.dioptra-free-ebook-download-button {
  align-items: center;
  background-color: #231f20;
  display: flex;
  gap: 15px;
  justify-content: center;
  border: 0;
  color: #fff;
  font-size: 16px;
  padding: 0.5rem;
  text-align: center;
  transition: all .3s ease-in-out;
  width: 100%;
  border-radius: 3px;
}
.dioptra-free-ebook-download-button-text {
  color: #fff;
  font-size: 16px;
}
.dioptra-free-ebook-download-head-text {
  margin: 0;
  font-size: 18px;
}
.dioptra-free-ebook-download-body-text {
  margin: 0;
}
.dioptra-free-ebook-download-close-button {
  background: white;
  border-radius: 20px;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: #ef1b1b;
  z-index: 9999;
  transition: all .2s ease-out;
  span {
    i {
      font-weight: 900;
    }
  }
  &:hover {
    transform: scale(1.5);
  }
  &:active {
    transform: scale(0.8);
  }
}
.product-name {
  color: #D2232A;
}
.dioptra-input-field {
  border: 1px solid #707070;
  &::placeholder {
    color: #231F20;
  }
}
.apple-tooltip {
  display: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100%;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  font-size: 12px;
  white-space: pre-wrap;
  z-index: 1000;
  width: 200px;
}
.dioptra-free-ebook-download {
  width: 100%;
}
.dioptra-free-ebook-download-button-container {
  display: grid;
  align-content: flex-end;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
}
</style>
